import { TreeNode } from 'react-dropdown-tree-select';
import { EnhetsgruppeTreeItem } from 'services/KjederegisteretAdminApi/EnhetsgrupperingApi/types';
import { IEnhetsgruppeNode } from './types';

export class EnhetsgruppeTreHelper {
  static updatePreSelectedNodes = (
    node: IEnhetsgruppeNode,
    preSelectedNodeIDS: number[],
    preSelectedNodeNumbers: number[],
    disableTopNodes: boolean,
    parent?: IEnhetsgruppeNode,
  ) => {
    let isChecked = preSelectedNodeIDS.includes(node.id);
    let isParentPreSelected = parent ? preSelectedNodeIDS.includes(parent.id) : false;

    if (!isChecked) {
      isChecked = preSelectedNodeNumbers.includes(node.nr);
    }

    if (!isParentPreSelected && parent) {
      isParentPreSelected = preSelectedNodeNumbers.includes(parent.nr);
    }

    const item: IEnhetsgruppeNode = {
      label: node.label,
      id: node.id,
      idOver: node.idOver,
      name: node.name,
      nr: node.nr,
      kjedenr: node.kjedenr,
      disabled: disableTopNodes && node.children && node.children.length > 0 ? true : false,
      children: [],
      checked: isChecked || isParentPreSelected,
      enhetgrupperingType: node.enhetgrupperingType,
    };
    if (node.children) {
      node.children.forEach((nodeChild: IEnhetsgruppeNode) => {
        item.children.push(
          EnhetsgruppeTreHelper.updatePreSelectedNodes(
            nodeChild,
            preSelectedNodeIDS,
            preSelectedNodeNumbers,
            disableTopNodes,
            item,
          ),
        );
      });
    }
    return item;
  };

  static treeNodeToEnhetsgruppeNode = (
    node: TreeNode,
    preSelectedNodeIDS: number[],
    preSelectedNodeNumbers: number[],
    disableTopNodes: boolean,
  ): IEnhetsgruppeNode => {
    let isChecked = false;
    if (preSelectedNodeIDS && preSelectedNodeIDS.length > 0) {
      isChecked = preSelectedNodeIDS.includes(node.id);
    }

    if (preSelectedNodeNumbers && preSelectedNodeNumbers.length > 0) {
      isChecked = preSelectedNodeNumbers.includes(node.nr);
    }

    const item: IEnhetsgruppeNode = {
      label: node.label,
      id: node.id,
      idOver: node.idOver,
      name: node.name,
      nr: node.nr,
      kjedenr: node.kjedenr,
      disabled: disableTopNodes && node?._children?.length > 0 ? true : false,
      checked: isChecked,
      enhetgrupperingType: node.enhetgrupperingType,
      children: [],
    };

    if (node.children) {
      node.children.forEach((childNode: TreeNode) => {
        item.children.push(
          EnhetsgruppeTreHelper.treeNodeToEnhetsgruppeNode(
            childNode,
            preSelectedNodeIDS,
            preSelectedNodeNumbers,
            disableTopNodes,
          ),
        );
      });
    }

    return item;
  };

  // Maps data returned from the API to the IEnhetsgruppeNode format
  static mapToEnhetsgruppeNode = (
    node: EnhetsgruppeTreeItem,
    preSelectedNodeIDS: number[],
    preSelectedNodeNumbers: number[],
    disableTopNodes: boolean,
    parent?: IEnhetsgruppeNode,
    facetCounts?: Map<number, number>,
  ): IEnhetsgruppeNode => {
    let isChecked = preSelectedNodeIDS.includes(node.id);
    let isParentPreSelected = parent && preSelectedNodeIDS.includes(parent.id);

    if (!isChecked) {
      isChecked = preSelectedNodeNumbers.includes(node.enhetgrupperingnr);
    }

    if (!isParentPreSelected) {
      isParentPreSelected = parent && preSelectedNodeNumbers.includes(parent.nr);
    }

    const baseLabel = `${node.name} - ${node.enhetgrupperingtypekode}`;
    const label = facetCounts
      ? `${baseLabel} (${(facetCounts.get(node.enhetgrupperingnr) ?? 0).toLocaleString('nb-NO')})`
      : baseLabel;

    const item: IEnhetsgruppeNode = {
      label,
      id: node.id,
      idOver: node.enhetgrupperingIDOver,
      name: node.name,
      nr: node.enhetgrupperingnr,
      kjedenr: node.kjedenr,
      enhetgrupperingType: node.enhetgrupperingtypekode,
      disabled: disableTopNodes && node.children && node.children.length > 0 ? true : false,
      children: [],
      checked: isChecked || isParentPreSelected,
    };

    if (node.children) {
      node.children.forEach((childNode: EnhetsgruppeTreeItem) => {
        item.children.push(
          EnhetsgruppeTreHelper.mapToEnhetsgruppeNode(
            childNode,
            preSelectedNodeIDS,
            preSelectedNodeNumbers,
            disableTopNodes,
            item,
            facetCounts,
          ),
        );
      });
    }
    return item;
  };
}
